<template>
  <div class="empty-list">
      <img src="@/assets/img/epmty-list.png">
      <p>Showcase your highlights right now!</p><br>
      <Button type="primary" @click="$emit('change')"> + Add</Button>
  </div>
</template>

<script>
export default { // 空白内容
  name:  'emptyList', 
}
</script>

<style scoped lang="scss">
.empty-list {
    height: 500px;
    padding-top: 140px;
    text-align: center;
	color: #565656;
    img {
        display: inline-block;
        margin-bottom: 46px;
    }
    p {
        margin-bottom: 29px;
    }
}
</style>
